<template>
	<StandardModal
		open
		small
		:title="$t(text.title)"
		:confirmText="$t('common_button_delete')"
		:confirmProps="{ danger: true, loading: isLoading }"
		@confirm="deleteAnnouncement"
		@cancel="cancel"
		ref="modal"
	>
		<div class="modal-wrapper">
			<TrashCanIcon halo />
			{{ $t(text.desc) }}
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal } from '@/components/common'
import { TrashCanIcon } from '@/icons'
import { getAnnouncement, getMyUser } from '@/store'
import {
	deleteAnnouncement,
	deleteAnnouncementRecipient,
} from '@/api/announcement'

export default {
	name: 'AnnouncementDeleteModal',
	components: { StandardModal, TrashCanIcon },
	props: {
		announcementId: [Number, String],
		forEveryone: { type: Boolean, default: null },
	},
	data() {
		return { isLoading: false }
	},
	computed: {
		text() {
			if (this.forEveryone) {
				return {
					title: 'announcements_sent_confirmdelete_button',
					desc: 'announcements_sent_confirmdelete_message',
				}
			}
			const me = getMyUser()
			const announcement = getAnnouncement(this.announcementId)
			if (me.isAdmin || announcement.isSentByMe) {
				return {
					title: 'announcements_sent_confirmdelete_me_button',
					desc: 'announcements_sent_confirmdelete_me_message',
				}
			}
			return {
				title: 'common_button_delete',
				desc: 'announcements_sent_confirmdelete_general_message',
			}
		},
	},
	emits: ['cancel'],
	methods: {
		cancel() {
			this.$emit('cancel')
		},
		async deleteAnnouncement() {
			this.isLoading = true
			try {
				if (this.forEveryone) {
					await deleteAnnouncement(this.announcementId)
				} else {
					await deleteAnnouncementRecipient(this.announcementId)
				}
				this.$router.replace('/announcements')
				this.cancel()
			} catch (e) {
				console.error(e)
				this.$refs.modal.$alert.error()
			}
			this.isLoading = false
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.modal-wrapper {
	@include flex-column-center;
	max-width: 300px;
	margin: 24px auto;
	text-align: center;
	.pronto-icon {
		color: var(--red-200);
		font-size: 50px;
		margin-bottom: 24px;
	}
}
</style>
